export class Rule {
  mode: string; // Examples: +cruda, -cd, +cr-a
  res: string; // Example: consumers.*
  dom?: string; // Optional, example: brand.uuid.06d8c1aa-290e-43ad-a632-4fdb769b2486
  tokenDom?: string;
}
